import { supabase } from "../db";

const signTable = "draft_signatures";

/**
 * Add or update a signature for a user
 */
export const addSignature = async (user_id, signerRole, signatureUrl) => {
  if (!["applicant", "caregiver", "hr"].includes(signerRole)) {
    throw new Error("Invalid signer role");
  }

  // Upsert - insert if not exists, update if exists
  const { data, error } = await supabase
    .from(signTable)
    .upsert(
      { 
        user_id, 
        signer_role: signerRole, 
        signature_url: signatureUrl,
        signed_at: new Date().toISOString()
      },
      { 
        onConflict: 'user_id', // Since user_id is primary key
        ignoreDuplicates: false 
      }
    )
    .select()
    .single();

  if (error) throw error;
  return data;
};

/**
 * Get signature for a user
 */
export const getSignatureByUser = async (user_id) => {
  const { data, error } = await supabase
    .from(signTable)
    .select("*")
    .eq("user_id", user_id)
    .single();

  if (error && error.code !== 'PGRST116') throw error; // PGRST116 = no rows
  return data;
};

/**
 * Delete signature for a user
 */
export const deleteSignature = async (user_id) => {
  const { error } = await supabase
    .from(signTable)
    .delete()
    .eq("user_id", user_id);

  if (error) throw error;
  return { success: true };
};